import PropTypes from 'prop-types';
import qs from 'query-string';
import { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigationType } from 'react-router';
import { notification } from 'ui';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { withRouter } from 'utils/withRouter';
import { changeNavigationContext, locationChange } from './navigation-actions';

const notificationKeysToClose = ['redirect_error'];

const NavigationListener = ({
  history,
  changeContext,
  changeListener,
  context,
  technician,
}) => {
  const location = useLocation();
  const [lastSearchFilter, setLastSearchFilter] = useState('');
  const action = useNavigationType();
  const logToAppInsights = (name) => {
    const { appInsights } = window;
    let n = 'Unknown page';
    if (name) {
      if (name.match(/create-order/)) {
        n = 'Create-order';
      } else if (name.match(/create-ticket/)) {
        n = 'Create-ticket';
      } else {
        const page = name.match(/^\/[^/]*/);
        n = page ? `${page[0].charAt(1).toUpperCase()}${page[0].substr(2)}` : name;
      }
    }
    appInsights?.trackPageView({ name: n, uri: name });
  };

  // eslint-disable-next-line complexity
  useDeepCompareEffect(() => {
    let lastContext, lastTechnician;
    lastContext = context;
    lastTechnician = technician;
    const isDirectSearch = location?.pathname?.includes('/direct/');
    notificationKeysToClose.forEach(n => notification.destroy(n));

    if (window.location.search) {
      const queryStrings = qs.parse(window.location.search);
      if (queryStrings.context || (queryStrings.technician && !isDirectSearch)) {
        changeContext({
          context: queryStrings.context,
          technician: queryStrings.technician,
          shouldUpdate: true,
          searchFilters: queryStrings?.searchFilters || '',
        });
      }
    }
    if (action === 'PUSH') {
      logToAppInsights(location.pathname);
      changeListener({ location, action });
      if (
        (location.state && location.state.context) ||
        (location.state && location.state.searchFilters) ||
        (location.state && location.state.technician && !isDirectSearch)
      ) {
        changeContext({
          context: location.state.context || '',
          technician:
            location.state.technician === '' ? '' : location.state.technician || lastTechnician,
          shouldUpdate: true,
          searchFilters: location.state.searchFilters || '',
        });
        lastContext = location.state.context;
        lastTechnician = location.state.technician;
      } else if (location.state && location.state.clearContext) {
        changeContext({
          context: '',
          technician: '',
          shouldUpdate: false,
          searchFilters: location.state.searchFilters || '',
        });
        lastContext = '';
        lastTechnician = '';
      } else if (context !== lastContext || (technician !== lastTechnician && !isDirectSearch)) {
        // this only gets executed when clicked in navigation bar
        // clicked on navigation bar ==> item is already present
        // ==> no update needed
        changeContext({
          context: lastContext,
          technician: lastTechnician,
          shouldUpdate: false,
          searchFilters: location?.state?.searchFilters || '',
        });
      }
      // eslint-disable-next-line
      const url = `${location.pathname}${lastContext ? `?${location.state?.searchFilters ? `searchFilters=${location.state.searchFilters}&` : ''
        }context=${lastContext}` : location.state?.searchFilters ?
        `?searchFilters=${location.state.searchFilters}` : ''
        }${lastTechnician ? `&technician=${lastTechnician}` : ''
        }`;
      history.replace(
        url,
        {
          ...location.state,
          cancelBlock: location.state?.cancelBlock,
        },
      );
    } else if (action === 'REPLACE') {
      const queryStrings = qs.parse(location.search);
      if (!queryStrings.context && lastContext) {
        // eslint-disable-next-line max-len
        const url = `${location.pathname}?${location.state?.searchFilters ? `searchFilters=${location.state?.searchFilters}&` : ''}context=${lastContext}`;
        history.replace(url, location.state);
      }
      if (!queryStrings.technician && lastTechnician) {
        // eslint-disable-next-line max-len
        const url = `${location.pathname}?${location.state?.searchFilters ? `searchFilters=${location.state?.searchFilters}&` : ''}context=${lastContext}&technician=${lastTechnician}`;
        history.replace(url, location.state);
      }
      if ((!queryStrings.context && !lastContext) &&
        (!queryStrings.technician && !lastTechnician) &&
        (location?.state?.searchFilters || '') !== lastSearchFilter) {
        setLastSearchFilter(location?.state?.searchFilters || '');
        // eslint-disable-next-line max-len
        const url = `${location.pathname}${location.state?.searchFilters ? `?searchFilters=${location.state?.searchFilters}` : ''}`;
        history.replace(url, location.state);
      }
    }
  }, [{
    pathname: location.pathname,
    search: location.search,
    state: location.state,
  }]);

  return null;
};

NavigationListener.propTypes = {
  history: PropTypes.object,
  changeContext: PropTypes.func.isRequired,
  changeListener: PropTypes.func.isRequired,
  context: PropTypes.string,
  technician: PropTypes.string,
};

const mapDispatchToProps = {
  changeContext: changeNavigationContext,
  changeListener: locationChange,
};

const mapStateToProps = state => ({
  context: state.navigation.activeContext,
  technician: state.navigation.activeTechnician,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(NavigationListener));
